


const displayImageList:any = [];
const uploadImageList:any = [];
const displayEKGImageList:any = [];
const uploadEKGImageList:any = [];

export const ImageService = {
    displayImageList,
    uploadImageList,
    displayEKGImageList,
    uploadEKGImageList
  };